import BaseModelAPI from '../BaseModelAPI';

export default class DownloadProcessList extends BaseModelAPI {

	static entity = 'downloadprocesslist'
	static entityName = 'downloadprocess';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
